import React, { FC } from 'react';
import cn from 'classnames';
require("./Switcher-Slider.css");
var styles = {
  "Slider": "Switcher-Slider-module-Slider_2x1"
};
export const SwitchSlider = ({
  state
}) => /*#__PURE__*/React.createElement("span", {
  className: cn(styles.Slider),
  role: "checkbox",
  "aria-checked": state
});